import React, { useEffect } from 'react';
import { Form, Col, Input } from 'antd'

const PropertyCoordinatesFields = (props: { 
  handleChange: void | any,
  validateFields: boolean,
  longitude: string,
  latitude: string,
  address: string,
  tabValue: number,
  useForm: any,
  validate: void | any
}) => {

  useEffect(() => {
    props.validate()
  }, [])

  return (
    <>
      <div className={props.tabValue === 1 ? "col-12 d-flex py-3" : 'd-none'}>
      <Col span={12}>
        <Form.Item
          label="Longitude"
          name='longitude'
          rules={[
            {
              required: props.tabValue === 1,
              message: 'Please enter a Longitude',
            },
            {
              validator: (_, value) => 
               +value >= -180.000000 && +value <= 180.000000 ? 
                Promise.resolve() : value ? 
                  Promise.reject(new Error('Please enter a correct longitude value')) 
                  : Promise.resolve(),
            },
          ]}
        >
          <Input 
            value='props.longitude' 
            onChange={(event) => props.handleChange(event,'longitude')}
          />
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item
          label="Latitude"
          name='latitude'
          rules={[
            {
              required: props.tabValue === 1,
              message: 'Please enter correct latitude value',
            },
            {
              validator: (_, value) => 
               +value >= -90.000000 && +value <= 90.000000 ? 
                Promise.resolve() : value ? 
                  Promise.reject(new Error('Please enter a correct latitude value')) 
                  : Promise.resolve(),
            },
          ]}
        >
          <Input 
            value='props.latitude' 
            onChange={(event) => props.handleChange(event,'latitude')}
          />
        </Form.Item>
      </Col>
    </div>
    </>
  )
}

export default PropertyCoordinatesFields
